import { Dialog, DialogWindow } from '../../widgets/dialog';
import { NotificationBanner } from '../../widgets/notificationBanner';
import React, { FC } from 'react';
import { T } from 'src/shared/helpers';
import CheckCircleIcon from 'src/shared/icons/check-circle-solid.svg';
import styled from 'styled-components';

const CustomDialogWindow = styled(DialogWindow)`
    flex: 1;
    max-width: 600px;
`;

const DialogContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    text-align: center;
    padding: 20px;
`;

const SuccessIconWrapper = styled.div`
    svg {
        width: 64px;
        height: 64px;
        color: #4caf50;
    }
`;

const Title = styled.h2`
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: ${(props) => props.theme.app.textColor};
`;

const BannersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    text-align: left;
`;

interface PaymentSuccessDialogProps {
    salesChannelID: string;
    onProceedToNextStep: () => void;
    onCancel: () => void;
}

const PaymentSuccessDialog: FC<PaymentSuccessDialogProps> = ({ salesChannelID, onProceedToNextStep, onCancel }) => {
    return (
        <Dialog
            windowDecorator={CustomDialogWindow}
            title={T._('Payment Successful', 'Admin')}
            onClose={onCancel}
            buttons={[
                {
                    label: T._('Proceed to Next Step', 'Admin'),
                    onClick: onProceedToNextStep
                }
            ]}
        >
            <DialogContent>
                <SuccessIconWrapper>
                    <CheckCircleIcon />
                </SuccessIconWrapper>
                <Title>{T._('Payment Completed Successfully', 'Admin')}</Title>
                <BannersWrapper>
                    <NotificationBanner
                        type='INFO'
                        content={
                            <p>
                                {T._(
                                    'Your payment has been processed successfully. Click "Proceed to Next Step" to continue with the sales channel switch.',
                                    'Admin'
                                )}
                            </p>
                        }
                    />
                    <NotificationBanner
                        type='WARNING'
                        title={T._('Subscription Required', 'Admin')}
                        content={
                            <p>
                                {T._(
                                    'As part of the next step, your current subscription will be cancelled and you will need to subscribe to a new plan. Remember: you must select at least the GROW plan to complete the switch.',
                                    'Admin'
                                )}
                            </p>
                        }
                    />
                </BannersWrapper>
            </DialogContent>
        </Dialog>
    );
};

export default PaymentSuccessDialog;
